import { Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { AppTextService } from '@fi-shared/app-text';
import { TabsModuleBase } from '@fi-app/utilities/tabs/tabs-module-base';
import { FiChecklistStatesService } from '@fi-app/checklist/fi-checklist-states.service';

@Component({
    selector: 'fi-checklist-list-navigation-tabs',
    templateUrl: './checklist-list-navigation-tabs.component.html',
    styleUrls: ['./checklist-list-navigation-tabs.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class ChecklistListNavigationTabsComponent extends TabsModuleBase implements OnInit {
    constructor(
        private injector: Injector,
        private accessToApplicationTypeService: AccessToApplicationTypeService,
        private appTextService: AppTextService,
        private fiChecklistStatesService: FiChecklistStatesService,
    ) {
        super(injector);
    }

    ngOnInit() {
        this.tabs = this.fiChecklistStatesService.getChecklistSettingsTabs();
        super.updateSelectedTabFromState();
    }
}
